module.exports = __webpack_public_path__ + "media/bgm_115_en.ea25ff51.m4a";